import { RouteConfig } from "vue-router";

const matrizPagos: RouteConfig = {
  path: "/matrizPagos",
  name: "matrizPagos",
  component: () => import(/* webpackChunkName: "matriz-pagos" */ "@/views/MatrizPagos.vue"),
};

export default matrizPagos;
